'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("imgScale", function () {
  return {
    restrict: "A",
    controller: function controller($scope, $element) {
      var ctrl = this,
        maxWidth = null,
        maxHeight = null;
      var img = $element;
      if (!img.is("img")) {
        img = $element.find("img");
      }
      if (!img) {
        console.log("Pas d'<img> trouvée par la directive imgScale");
        return;
      }
      ctrl.setDimensions = function (width, height) {
        maxWidth = width && parseInt(width) || null;
        maxHeight = height && parseInt(height) || null;
      };
      ctrl.scaleImage = function () {
        // Remove all attributes and CSS rules
        img.removeAttr("height width");
        img.css({
          height: "auto",
          width: "auto"
        });
        var originalHeight = img[0].height,
          originalWidth = img[0].width,
          heightRatio = maxHeight ? maxHeight / originalHeight : null,
          widthRatio = maxWidth ? maxWidth / originalWidth : null,
          useHeightRatio = heightRatio != null && (widthRatio == null || heightRatio < widthRatio),
          scaledHeight,
          scaledWidth;
        if (useHeightRatio) {
          scaledHeight = originalHeight * heightRatio;
          scaledWidth = originalWidth * heightRatio;
        } else {
          scaledHeight = originalHeight * widthRatio;
          scaledWidth = originalWidth * widthRatio;
        }
        img.css({
          height: parseInt(scaledHeight),
          width: parseInt(scaledWidth)
        });
        $scope.$emit("$resize:required");
      };
    },
    link: function link($scope, $el, $attrs, ctrl) {
      var img = $el;
      if (!img.is("img")) {
        img = $el.find("img");
        if (!img) {
          console.log("Pas d'<img> trouvée par la directive imgScale");
          return;
        }
      }
      if ($attrs.imgWidth || $attrs.imgHeight) {
        $attrs.imgWidth && img.width($attrs.imgWidth + "px");
        $attrs.imgHeight && img.height($attrs.imgHeight + "px");
      } else {
        img.hide();
      }
      var setDimensions = function setDimensions() {
        $el.show();
        ctrl.setDimensions($attrs.imgWidth, $attrs.imgHeight);
        ctrl.scaleImage();
      };
      img.on("load", function () {
        setDimensions();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/imgScale.js
// module id = 2968
// module chunks = 13